module.exports = __webpack_public_path__ + "061d88a0fe611095e43ead4e172600c4.svg";